import { Component, OnInit, Input } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivityService } from 'src/app/services/activity.service';

import { Procces, Customer, InfoInstance } from '../../classes';

@Component({
  selector: 'app-acitivitypopup',
  templateUrl: './acitivitypopup.component.html',
  styleUrls: ['./acitivitypopup.component.css']
})
export class AcitivitypopupComponent implements OnInit {

  @Input() activityName: string;
  @Input() process: Procces;
  @Input() customer: Customer;
  @Input() operator: any;
  @Input() info: InfoInstance;

  token: string;
  userActive: string;
  folder_id: string;
  showDoc: boolean = false;
  showGetColor: boolean = false;
  showCheckDoc: boolean = false;

  constructor(
    private globals: GlobalService,
    private activityService: ActivityService,
    private activeModal : NgbActiveModal,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    if(!this.token){
      this.token = this.globals.getToken();
    }
    this.userActive = this.globals.storagedUser;
    this.selectTemplete();
    console.log("Info instance: ", this.info );
    
    
  }

  selectTemplete(){
    if(this.activityName == 'Upload documenti' || this.activityName == 'Carica documenti' || this.activityName == 'Upload documenti cliente' || this.activityName == 'Ricezione documenti'){
      this.folder_id = this.info.customer.folder_id;
      return this.showDoc = true;
    }
    if(this.activityName == 'Cambia colore'){
      return this.showGetColor = true;
    }
    if(this.activityName == 'Controllo documenti'){
      console.log("Dentro");
      
      this.folder_id = this.info.customer.folder_id;
      return this.showCheckDoc = true
    }
  }

  confirm(){
    let toSend;
    if(this.showDoc){
      toSend = {
        procces: this.process
      }
    }
    if(this.showCheckDoc){
      toSend = {
        procces: this.process,
        info: {
          doc_ok: true
        }
      }
    }
    this.activityService.inputInstance(this.token, toSend).subscribe(
      res => {
        console.log("Inviata: ", res);
        this.close();
      },
      err => {
        console.error("Errore: ", err);
        
      }
    )
  }
  refuses(){
    let toSend;
    if(this.showCheckDoc){
      toSend = {
        procces: this.process,
        info: {
          doc_ok: false
        }
      }
    }
    this.activityService.inputInstance(this.token, toSend).subscribe(
      res => {
        console.log("Inviata: ", res);
        this.close();
      },
      err => {
        console.error("Errore: ", err);
        
      }
    )
  }

  close(){
    this.activeModal.close();
  }

  cancel(){
    this.activeModal.close('cancel')
  }

}
